import { render, staticRenderFns } from "./print.vue?vue&type=template&id=36f95021&scoped=true&"
import script from "./print.vue?vue&type=script&lang=ts&"
export * from "./print.vue?vue&type=script&lang=ts&"
import style0 from "./print.vue?vue&type=style&index=0&id=36f95021&lang=scss&scoped=true&"
import style1 from "./print.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f95021",
  null
  
)

export default component.exports